import { Component, OnInit, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { ErrorMessageModalComponent } from '../../modals/error-message-modal/error-message-modal.component'

import { SiteService } from '../../../services/site.service'
import { MessageService } from '../../../services/message.service'
import { TranslateService } from '@ngx-translate/core'
import { CustomerRequestsService } from '../../../services/customer-requests.service'
import { AuthenticationService } from '../../../services/authentication.service'
import { CustomerChangeRequestTypes } from '../../../enumeration'
import { SubmitInsuranceModalComponent } from '../../modals/submit-insurance-modal/submit-insurance-modal.component'

@Component({
    selector: 'app-request-list',
    templateUrl: './request-list.component.html',
    styleUrls: ['./request-list.component.scss'],
    standalone: false
})
export class RequestListComponent implements OnInit 
{
  constructor(
    private router: Router,
    public dialog: MatDialog,
    private siteService: SiteService,
    private messageService: MessageService,
    private translateService: TranslateService,
    private customerRequestsService: CustomerRequestsService,
    private authenticationService: AuthenticationService
  ) 
  { 

  }

  ngOnInit() 
  {
    if(this.siteService.isLockedOut)
    {
      const dialogConfig = new MatDialogConfig()
      dialogConfig.width = '500px',
      dialogConfig.data = {
        title: this.translateService.instant('REQUEST_ACCOUNT_VALIDATION_ERR_TITLE'),
        message: this.translateService.instant('REQUEST_ACCOUNT_VALIDATION_ERR_BODY_LOCK'),
      }
      
      this.dialog.open(ErrorMessageModalComponent, dialogConfig)
      this.router.navigate(['/contact-us'])
    }
  }

  handleRequestAddressChange()
  {
    this.siteService.customerRequestType = CustomerChangeRequestTypes.AddressChange
    this.nextStep('/address-change')
  }

  handleRequestBankAccountChange()
  {
    this.siteService.customerRequestType = CustomerChangeRequestTypes.BankAccountChange
    this.nextStep('/bank-account-change')
  }

  handleRequestEmailChange()
  {
    this.siteService.customerRequestType = CustomerChangeRequestTypes.EmailChange
    this.nextStep('/email-change')
  }

  handleRequestLeaseTransfer()
  {
    this.siteService.customerRequestType = CustomerChangeRequestTypes.LeaseTransfer
    this.nextStep('/lease-transfer')
  }

  handleRequestNameChange()
  {
    this.siteService.customerRequestType = CustomerChangeRequestTypes.NameChange
    this.nextStep('/name-change')
  }

  handleRequestOtherChange()
  {
    this.siteService.customerRequestType = CustomerChangeRequestTypes.OtherRequest
    this.nextStep('/other-change')
  }

  handleRequestPaymentDateChange()
  {
    this.siteService.customerRequestType = CustomerChangeRequestTypes.PaymentDateChange
    this.nextStep('/payment-date-change')
  }

  handleRequestPhoneChange()
  {
    this.siteService.customerRequestType = CustomerChangeRequestTypes.PhoneChange
    this.nextStep('/phone-change')
  }

  nextStep(routeLink: string)
  {
    if(this.authenticationService.canActivate())
    {
      return this.customerRequestsService.checkChangeRequestsAndProceed(this.siteService.customerRequestType)
      .then((result) =>
      {
        if(result)
        {
          this.router.navigate([routeLink]);
        }
      })
    } 
  }

  submitInsuranceInfo()
  {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '1000px',
    this.dialog.open(SubmitInsuranceModalComponent, dialogConfig)
  }

}
